import { useTranslation } from "@repo/i18n";
import { ShellFrame } from "../shell/ShellFrame";

/**
 * Manage links sent before the venue id joined the URL (`/manage/<token>`, `/m/<token>`). Every manage
 * call needs the venue to resolve the tenant, so these can't open the booking: tell the guest what to do
 * instead of showing a not-found page. No API call, and the token is never echoed.
 */
export function LegacyManageLink() {
  const { t } = useTranslation();
  return (
    <ShellFrame>
      <section aria-labelledby="manage-legacy" data-testid="manage-legacy">
        <h2 id="manage-legacy">{t("widget.manage.legacy.title")}</h2>
        <p>{t("widget.manage.legacy.body")}</p>
      </section>
    </ShellFrame>
  );
}
